import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { clintonIAConfig } from "./data";

export default function ClintonIAPage() {
  return <CityPageTemplate config={clintonIAConfig} />;
}